import { Alert, IUIState } from "@/store/ui/IUIState";
import { IUIModule } from "@/store/ui/IUIModule";

const STORAGE_KEY = process.env.VUE_APP_STORE_KEY;

const defaultValues: IUIState = {
  title: "",
  language: "en",
  loadingOverlay: {
    isLoading: false,
    loadingEnabled: true,
    loadingMessage: "Loading...",
  },
  alert: {
    show: false,
    header: "",
    message: "",
  },
  carItemQuantity: 0,
  isSidebarCollapsed: true,
  emMethod: "C",
};

export const uiModule: IUIModule = {
  namespaced: true,
  state: {
    ...defaultValues,
    ...JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}").ui,
  },
  getters: {
    title: (state: IUIState): string => state.title,
    language: (state: IUIState): string => state.language,
    isLoading: (state: IUIState): boolean =>
      (state.loadingOverlay.isLoading ?? false) &&
      state.loadingOverlay.loadingEnabled,
    loadingEnabled: (state: IUIState): boolean =>
      state.loadingOverlay.loadingEnabled ?? false,
    alert: (state: IUIState): Alert => state.alert,
    carItemQuantity: (state: IUIState): number => state.carItemQuantity,
    isSidebarCollapsed: (state: IUIState): boolean => state.isSidebarCollapsed,
    emMethod: (state: IUIState): string => state.emMethod,
  },
  mutations: {
    setTitle: (state: IUIState, title: string): void => {
      state.title = title;
    },
    setLanguage: (state: IUIState, language: string): void => {
      state.language = language;
    },
    setIsLoading: (state: IUIState, isLoading: boolean): void => {
      state.loadingOverlay.isLoading = isLoading;
    },
    setLoadingEnabled: (state: IUIState, loadingEnabled: boolean): void => {
      state.loadingOverlay.loadingEnabled = loadingEnabled;
    },
    setAlertMessage: (
      state: IUIState,
      payload: { header: string; message: string }
    ): void => {
      state.alert.header = payload.header;
      state.alert.message = payload.message;
    },
    setAlertShow: (state: IUIState, show: boolean): void => {
      state.alert.show = show;
    },
    setCarItemQuantity: (state: IUIState, quantity: number): void => {
      state.carItemQuantity = quantity;
    },
    setIsSidebarCollapsed: (state: IUIState, isCollapsed: boolean): void => {
      state.isSidebarCollapsed = isCollapsed;
    },
    setEmMethod: (state: IUIState, emMethod: string): void => {
      state.emMethod = emMethod;
    },
  },
  actions: {},
};
export default uiModule;
